import React from 'react';
import PixiGamePlayerRow from "./PixiGamePlayerRow"
import { Container } from '@pixi/react';
import { pixiGameUtils } from '../PixiGame/PixiGameUtils'

class PixiGamePlayersInfoPanel extends React.Component
{
  render()
  {
    const stageRenderData = this.props.stageRenderData;
    const playerData = this.props.playerData;
    const clientPlayerIndex = this.props.clientPlayerIndex;
    const panelWidth = this.props.panelWidth;
    const panelHeight = this.props.panelHeight;

    const numPlayers = playerData.playersJoined.length;

    let uiRightPanelContent = [];
    const rowSpacing = -4;
    const playerRowHeight = 118;
    const standardRowHeight = numPlayers > 4
      ? ( panelHeight - playerRowHeight - ( ( numPlayers - 1 ) * rowSpacing ) ) / ( numPlayers - 1 )
      : 84.3;

    let yOffset = -2 + ( ( numPlayers - 1 ) * ( standardRowHeight ) ) + playerRowHeight + ( numPlayers * rowSpacing );

    for( let idx = 0; idx < numPlayers; idx++ )
    {
      const pIndex = ( idx + clientPlayerIndex + 1 ) % numPlayers;
      const currentPlayerData = playerData.playersJoined[ pIndex ];
      const playerName = currentPlayerData.username;
      const isClientPlayerRow = idx === numPlayers - 1;
      const isCurrentPlayerTurn = pIndex === playerData.playerTurnIndex;
      const rowHeight = isClientPlayerRow ? playerRowHeight : standardRowHeight;
      const playerScore = playerData.scores ? playerData.scores[ pIndex ] : 0;
      const playerMeeples = playerData.meeples ? playerData.meeples[ pIndex ] : [];

      let playerIconSprite = pixiGameUtils.getPlayerIconSprite( currentPlayerData );

      yOffset -= rowHeight + rowSpacing;

      uiRightPanelContent.push(
        <PixiGamePlayerRow
          key={ idx.toString() }
          stageRenderData={ stageRenderData }
          textStyle={ this.props.textStyle }
          x={ this.props.x }
          y={ this.props.y - yOffset }
          width={ panelWidth }
          height={ rowHeight }
          playerName={ playerName }
          teamColourID={ currentPlayerData.colourID }
          playerScore={ playerScore }
          playerMeeples={ playerMeeples }
          isClientPlayerRow={ isClientPlayerRow }
          isCurrentPlayerTurn={ isCurrentPlayerTurn }
          playerIconSprite={ playerIconSprite }
          onClickedAction={ () => { this.props.onPlayerRowClicked( pIndex ); } }
        />
      );
    }

    return (

      <Container>
        { uiRightPanelContent }
      </Container>

    );
  }
}

export default PixiGamePlayersInfoPanel;
